import { AppointmentStatusKey } from '../../helpers/appointments';
import StatusChipBase from '../global/StatusChipBase';

interface Props {
  status: AppointmentStatusKey;
  // 'detail' = the 24px variant in the appointment detail header.
  size?: 'small' | 'medium' | 'detail';
}

const LABEL_BY_KEY: Record<AppointmentStatusKey, string> = {
  unconfirmed: 'Unconfirmed',
  confirmed: 'Confirmed',
  completed: 'Completed',
  canceled: 'Canceled',
  noShow: 'No-show',
};

function StatusChip({ status, size = 'medium' }: Props) {
  return (
    <StatusChipBase
      tokenKey={status}
      size={size}
      label={LABEL_BY_KEY[status]}
    />
  );
}

export default StatusChip;
